import styled from 'styled-components'

import { untilMd } from '@syconium/little-miss-figgy'

/**
 * @todo This is currently overused as a generic section wrapper. As a result it gets a bunch of CSS styles specific to its usages
 * We should try to split this up into some more specific wrappers.
 **/
export const EmbroiderySectionWrapper = styled.section<{ hasBorder?: boolean }>`
  margin-top: ${o => o.theme.spacing(5)};
  border-top: ${o =>
    o.hasBorder
      ? `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`
      : undefined};
  padding-top: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};

  &.multi-colors-section {
    margin-top: ${o => o.theme.spacing(5)};
  }

  &.size-section {
    margin-top: ${o => o.theme.spacing(2)};
    .size-section-title {
      scroll-margin-top: 80px;
    }
  }

  &.embroidery-settings-section {
    padding-top: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};
  }
  &.fit-section {
    margin-top: ${o => o.theme.spacing(4)};
  }

  &.personalize-section {
    margin-top: ${o => o.theme.spacing(6)};
    padding-top: 0;
    border: none;
  }

  ${untilMd} {
    padding: 0 ${o => o.theme.dimensions.layout.sidePadding.md}px;

    &.personalize-section {
      margin: 0;
      margin-top: ${o => o.theme.spacing(6)};
      padding: ${o => o.theme.spacing(0, 4)};
      padding-top: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};
      padding-bottom: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};
      border-top: ${o =>
        o.hasBorder
          ? `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`
          : undefined};
      border-bottom: ${o =>
        o.hasBorder
          ? `1px solid ${o.theme.color.stroke.neutral.border.decoration.on.background}`
          : undefined};
    }

    &.embroidery-settings-section {
      margin: 0 ${o => o.theme.spacing(4)};
      margin-top: ${o => o.theme.spacing(5)};
      padding: 0 0;
      padding-top: ${o => (o.hasBorder ? o.theme.spacing(5) : undefined)};
    }
  }
`
